import { isPlatformBrowser } from '@angular/common';
import {
  inject,
  Injectable,
  makeStateKey,
  PLATFORM_ID,
  TransferState,
} from '@angular/core';
import { DeviceType, RequestData } from '../../backend/model/request-data';
import { REQUEST_DATA } from '../../backend/utils/provide-tokens';
import { Locale } from '../../backend/model/locale';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RequestDataService {
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  private activatedRoute = inject(ActivatedRoute);
  private requestData!: RequestData;
  private readonly REQUEST_DATA_KEY = makeStateKey<RequestData>('request_data');

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const transferredRequestData = this.transferState.get<RequestData>(
        this.REQUEST_DATA_KEY,
        {} as RequestData
      );
      this.requestData = transferredRequestData;
      this.transferState.remove<RequestData>(this.REQUEST_DATA_KEY);
    } else {
      // on the server, we get the data from the injection token
      const requestData = inject(REQUEST_DATA);
      this.transferState.set<RequestData>(this.REQUEST_DATA_KEY, requestData);
      this.requestData = requestData;
    }
  }

  getRequestData(): RequestData {
    return this.requestData;
  }

  getLocale(): Locale {
    return this.requestData.locale;
  }

  getPosixLocale(): string {
    return `${this.requestData.locale.language.toLowerCase()}_${this.requestData.locale.country.toUpperCase()}`;
  }

  getTrackerId(): string {
    return this.requestData.userData.trackerId;
  }

  isClubeMember(): boolean {
    return this.requestData.userData.isClubeMember;
  }

  isWebView(): boolean {
    return this.requestData.device.isWebView;
  }

  getPageviewId(): string {
    return this.requestData.pageviewId;
  }

  getDeviceType(): DeviceType {
    return this.requestData.device.type;
  }

  getOperationId(): string {
    return this.requestData.operation_id;
  }

  getUow(): string {
    return this.requestData.uow;
  }

  isTest(): string | undefined {
    return this.activatedRoute.snapshot.queryParams['source']?.includes('test')
      ? '1'
      : undefined;
  }
}
